import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
} from 'react-admin';

export const CharacteristicGroupCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="description" multiline rows={3} fullWidth />
      <NumberInput source="sortOrder" defaultValue={0} />
    </SimpleForm>
  </Create>
);
